import Vue from 'vue'

import { Find, FindItem } from '@/api/data-logger'
import { IPanel } from '@/types/view'

import { SelectOption } from './types'
import { DataLog, Item } from '../../types/data-log'

export interface Layout {
  i: string
  x: number
  y: number
  w: number
  h: number
  moved: boolean
}

export interface Series {
  id: number
  name: string
  chartType: string
  dataLog: string
  measurement: string
  color: string
  customQuery: string
  edit: boolean
}

export interface Model {
  // eslint-disable-next-line
  attributes: any
  component: string
  // eslint-disable-next-line
  data: any
  layout: Layout
  query: Series[]
  title: string
}

export default Vue.extend({
  props: {
    value: Object,
  },
  data() {
    return {
      model: {} as IPanel,
      dataLoggerItems: [] as Item[],
      dataLoggerId: -1,
      dataloggers: [] as DataLog[],
    }
  },
  computed: {
    optsDataLogger(): SelectOption[] {
      return this.dataloggers.map((d: DataLog) => {
        return { value: d.id, text: d.name }
      })
    },
  },
  methods: {
    parseInput() {
      this.model = {
        ...this.value,
        query: this.value.query.map((q: string) => JSON.parse(q)),
      }
    },
    // eslint-disable-next-line
    parseModel(): IPanel {
      return {
        ...this.model,
        query: this.model.query.map((q) => JSON.stringify(q)),
      }
    },

    async find() {
      this.dataloggers = await Find()
    },

    async findItem() {
      this.dataLoggerItems = await FindItem({
        datalogId: this.dataLoggerId,
      } as Item)
    },
  },
  watch: {
    value: {
      deep: true,
      // eslint-disable-next-line
      handler: function(val: any) {
        const parsedModel = this.parseModel()
        if (JSON.stringify(val) != JSON.stringify(parsedModel)) {
          // this.model = this.value
          this.parseInput()
        }
      },
    },
    model: {
      deep: true,
      handler: function(val) {
        if (JSON.stringify(val) != JSON.stringify(this.value)) {
          this.$emit('input', this.parseModel())
        }
      },
    },

    dataLoggerId: async function() {
      await this.findItem()
    },
  },
})
